import { ProviderType } from 'shared/types/flowstep';

export class ProviderUrlMeta {
  private static readonly URL_META: Record<ProviderType, UrlMeta> = {
    [ProviderType.HS]: {
      canGetIdFromFlowstep: false,
    },
    [ProviderType.HubspotList]: {
      canGetIdFromFlowstep: true,
    },
    [ProviderType.SF]: {
      canGetIdFromFlowstep: false,
    },
    [ProviderType.CSV]: {
      canGetIdFromFlowstep: false,
    },
    [ProviderType.SalesforceReport]: {
      canGetIdFromFlowstep: false,
    },
    [ProviderType.SalesforceDebugReport]: {
      canGetIdFromFlowstep: false,
    },
    [ProviderType.SalesforceSoql]: {
      canGetIdFromFlowstep: false,
    }
  };

  static canGetIdFromFlowstep(providerType: ProviderType): boolean {
    return this.URL_META[providerType]?.canGetIdFromFlowstep ?? false;
  }

  static getUrlMeta(providerType: ProviderType): UrlMeta {
    return (
      this.URL_META[providerType] ?? {
        canGetIdFromFlowstep: false,
      }
    );
  }
}

interface UrlMeta {
  canGetIdFromFlowstep: boolean;
}
